var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_726_217",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_726_217",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADy0lEQVR4nO2dy04UQRSGOyawETEhLlQwxkTWoAtvT6BREUV8BhV9DoWdtxiMOy8LE3eoL6CvgIi6EdzLZSFB/ExlSh3bnmG6aU7VTP9fMglh5kyfc/6a09VV1dVJIoQQQgghhBBCCCFEAYADwA3gDfAeWKX9WfWxvAYmgIHoGgfQD0wD63Q+G8AL4GASA8AIsEz1WAbOh07+Td8iqsqGK7mhkn8G+BE6A5GIMBKi5lex7DRiCdhnKcDjhq5Ul2nLrqZKz/+4HmC/1YlXZHPdQgB3QSKymbEQYL7BwQXMWQiwokw3ZMVCANEECRAYCRAYCRAYCRAYCRAYCRAYCRCYThPgLTC4BV8HgXeWDpeb7eygLCc6Dpfg7yHL0dtystw8oLKZ8RM8A6mBvpcl+vwSI8ryuVkwZTOQmmv4zakSfT6FEWX53CyYMvgCjAG7tt3hzePZBVx0I5llBGbhcBnJ70siA+gDFqogwFgSKcB4FQQIXnYaAfR2vABbPHY3cAV47mv2qn/N+f+597o3+Y6zwKIvN2diiq8lQjkIXAI+t3CIT+6k2uR76uv8l1jiy5MIUweBHcBUgUNNOtuM75MAOQWY2oLekw2WVC743tjp0A0sN5YOUis7ab4Dd4DjwE7/cn/fA9YyPj8aa3yFsHKQ2gk3XfPdyXOoic2w/0w9H4Gu2OIrjJWD1Ho06ZY/1ILdkYxfwuXY4iuMlYPUupX13Mlhez9l+zS2+Apj5SDwIWV6LIftiaIr1qziK4yVg/y/Aq8nh21P0RVrVvEVpk0E6E3ZLsUWX2EClqDjOWxPpmxVggoI8CyVxLs5bB+kbJ/E1sAKE7gbOtyC3VF1Q8u7EPuUMl9sJoJP/teUjbufQRdiRX6i1KYK06z5YYeTvrfT4/9+kHEB9jPvLaRWDawwbTYYdyv2+JI2GY6ezHkY1/JvZw1HxxZf0i4OAqN+YG0zXM2/0G7xtYWDQJcbWHNjO34LmRX/mnVdTf9eV7vGZ+Jg5JPyu6sgQMP52tD4xWIdL8BcxAuz5qsgAH5OdtwNmm27w60N3I2VdQO6hcOiCRIgMBIgMBIgMBIgMBIgMBIgMBKgAgJou8rGLFkIkF6tIP4yayGANu0LvGmf28JdZHPVQoCBimxTH+fGrV6ER7nd63wemiTfC7BfvaF/+AbsNRPAi3Bae0j/2dXlnGny60Rwz4up+gMcJoIkv06Ec37//CqWnbNJDAB7/J2LVegdrfsHFtk9sKFV/MZL14BXfq1OJ+wzveJjmfGx2XQ1hRBCCCGEEEIIIUTSafwCUqoH9rkho7EAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.7cb7fb9c8e75a508905510e5b1683d85.svg";
export { ForwardRef as ReactComponent };